/* STICKYZOO — Region blocking.
   Config is injected by layout/theme.liquid as window.__SZ_REGION_BLOCK.
   If the visitor's country (Shopify localization.country.iso_code) is in the blocked
   list, the whole site is taken over by a full-screen "blocked" page, and (optionally)
   right-click / inspect shortcuts are disabled.
   Test the blocked page from any country by adding ?sz_block_preview=1 to the URL.
   NOTE: client-side gate — deters casual access, not a hard security boundary. */
(function () {
  var cfg = window.__SZ_REGION_BLOCK;
  if (!cfg || !cfg.blocked) return;

  var blocked = String(cfg.blocked).toUpperCase().split(/[^A-Z]+/).filter(Boolean);
  var country = String(cfg.country || '').toUpperCase();
  var preview = /[?&]sz_block_preview=1/i.test(location.search);

  if (!preview && (!country || blocked.indexOf(country) === -1)) return;

  var de = document.documentElement;
  de.style.visibility = 'hidden';            // avoid content flash before takeover
  try { if (window.stop) window.stop(); } catch (e) {}

  var title = cfg.title || 'You are blocked';
  var msg = cfg.message || '';
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  var done = false;
  function render() {
    if (done) return;
    done = true;
    try { document.title = title; } catch (e) {}
    var host = document.body || de;
    var d = document.createElement('div');
    d.id = 'sz-region-block';
    d.setAttribute('style', 'position:fixed;inset:0;width:100%;height:100%;z-index:2147483647;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;gap:14px;padding:24px;box-sizing:border-box;background:#000;color:#fff;font-family:Inter,system-ui,-apple-system,"Segoe UI",sans-serif;');
    d.innerHTML =
      '<div style="font-size:12px;letter-spacing:.25em;text-transform:uppercase;color:#9f1721;font-weight:800;">STICKYZOO</div>' +
      '<h1 style="font-size:26px;font-weight:700;text-transform:uppercase;letter-spacing:.02em;margin:0;">' + esc(title) + '</h1>' +
      (msg ? '<p style="font-size:14px;max-width:36ch;line-height:1.55;color:#bbb;margin:0;">' + esc(msg) + '</p>' : '');
    host.appendChild(d);
    de.style.overflow = 'hidden';
    de.style.visibility = 'visible';
  }

  if (document.body) render();
  else document.addEventListener('DOMContentLoaded', render);
  var iv = setInterval(function () { if (document.body) { clearInterval(iv); render(); } }, 15);
  setTimeout(function () { clearInterval(iv); render(); }, 4000);

  if (cfg.devtools) {
    var stop = function (e) { e.preventDefault(); e.stopPropagation(); return false; };
    document.addEventListener('contextmenu', stop, true);
    document.addEventListener('keydown', function (e) {
      var k = e.keyCode || e.which;
      // F12 · Ctrl/Cmd+Shift+I/J/C (devtools) · Ctrl/Cmd+U (view source)
      if (k === 123 ||
          ((e.ctrlKey || e.metaKey) && e.shiftKey && (k === 73 || k === 74 || k === 67)) ||
          ((e.ctrlKey || e.metaKey) && k === 85)) {
        return stop(e);
      }
    }, true);
  }
})();
